import { ACTION_TYPE_RESERVICE } from 'reservice'
import {
  removeNonPrintableCharParser,
  convertFullCollection,
  convertInvalidDate,
  trimString
} from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/dist/constants/proposal.js'
import _ from 'lodash'
import {
  CREATE_PROPOSALS,
  UPDATE_PROPOSALS,
  CREATE_LISTING_INFO_PROPOSAL,
  UPDATE_LISTING_INFO_PROPOSAL
} from '../actions/actionTypes'

const getConvertedAkamaiUrlCopy = (originCopy) => {
  if (_.isEmpty(originCopy) || !_.isString(originCopy)) {
    return originCopy
  }

  return originCopy.replace(/s\.yimg\.com/g, 'img.yec.tw')
}

const getConvertedAkamaiUrlPayload = (action = {}, copyPath) => {
  const payload = _.get(action, 'payload', {})
  const originCopy = _.get(payload, copyPath)
  const akamaiCopy = getConvertedAkamaiUrlCopy(originCopy)
  _.set(payload, copyPath, akamaiCopy)
  return payload
}

const communicator = store => next => action => {
  switch (action.type) {
    // CALL_SERVICE
    case ACTION_TYPE_RESERVICE: {
      // inject `wssid` to payload when reservice type as CALL_SERVICE
      // inject all of it for now, specify action types if you need to handle further more

      action.payload = action.payload || {} // prevent empty payload
      if (action.payload && !action.payload.wssid) {
        const { page } = store.getState()
        const wssid = page.wssid || ''
        action.payload = _.assign({}, action.payload, { wssid })
      }

      // intecept specific service by action name
      switch (action.reservice.name) {
        // 新增賣場、新增商品、修改賣場詳情
        case CREATE_PROPOSALS:
        case UPDATE_PROPOSALS: {
          const isUpdateCopy = _.get(action, 'payload.type') === PROPOSAL_TYPE.UPDATE_COPY
          const copyPath = isUpdateCopy ? 'listing.copy' : 'product.copy'
          action.payload = getConvertedAkamaiUrlPayload(action, copyPath)
          break
        }
        // 修改賣場資訊
        case CREATE_LISTING_INFO_PROPOSAL:
        case UPDATE_LISTING_INFO_PROPOSAL: {
          const copyPath = 'listing.copy'
          action.payload = getConvertedAkamaiUrlPayload(action, copyPath)
          break
        }
      }
      break
    }
  }

  if (_.has(action, 'payload.wssid')) {
    const payload = _.get(action, 'payload', {})
    // 發出請求和 api 有關時轉換 payload 內容
    const convertPaylaod = convertFullCollection(payload, value => {
      return _.flow(
        // 把 paylaod 裡看不到的字元清除，只保留 \t, \n, \r
        removeNonPrintableCharParser,
        // 轉換無效日期格式
        convertInvalidDate,
        trimString
      )(value)
    })
    _.set(action, 'payload', convertPaylaod)
  }

  return next(action)
}

export default communicator
